import { Schema } from 'effect';
import { HttpApiSchema } from 'effect/unstable/httpapi';

/** Shared wire errors emitted by the hosted core API. */
export const ApiNextAction = Schema.Struct({
  cmd: Schema.String,
  why: Schema.String,
});

export const ApiStringError = Schema.Struct({
  error: Schema.String,
  message: Schema.optionalKey(Schema.String),
  code: Schema.optionalKey(Schema.String),
  next_actions: Schema.optionalKey(Schema.Array(ApiNextAction)),
});

export const ApiNestedError = Schema.Struct({
  error: Schema.Struct({
    message: Schema.String,
    type: Schema.optionalKey(Schema.String),
    code: Schema.optionalKey(Schema.String),
  }),
  message: Schema.optionalKey(Schema.String),
  code: Schema.optionalKey(Schema.String),
  next_actions: Schema.optionalKey(Schema.Array(ApiNextAction)),
});

export const ApiError = Schema.Union([ApiStringError, ApiNestedError]);
export type ApiError = Schema.Schema.Type<typeof ApiError>;

export const ApiBadRequest = ApiError.pipe(HttpApiSchema.status(400));
export const ApiUnauthorized = ApiError.pipe(HttpApiSchema.status(401));
export const ApiForbidden = ApiError.pipe(HttpApiSchema.status(403));
export const ApiNotFound = ApiError.pipe(HttpApiSchema.status(404));
export const ApiGone = ApiError.pipe(HttpApiSchema.status(410));
export const ApiPayloadTooLarge = ApiError.pipe(HttpApiSchema.status(413));
export const ApiUnsupportedMediaType = ApiError.pipe(HttpApiSchema.status(415));
export const ApiUnprocessableEntity = ApiError.pipe(HttpApiSchema.status(422));
export const ApiInternalServerError = ApiError.pipe(HttpApiSchema.status(500));
export const ApiNotImplemented = ApiError.pipe(HttpApiSchema.status(501));
export const ApiServiceUnavailable = ApiError.pipe(HttpApiSchema.status(503));
